import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Importing translation files

import translationEN from "./locales/en/translation.json";
import translationFR from "./locales/fr/translation.json";
import routesEN from "./locales/en/routes.json";
import routesFR from "./locales/fr/routes.json";
import seoEN from "./locales/en/seo.json";
import seoFR from "./locales/fr/seo.json";

//Creating object with the variables of imported translation files
const resources = {
  en: {
    translation: translationEN,
    routes: routesEN.routes,
    seo: seoEN.seo,
  },
  fr: {
    translation: translationFR,
    routes: routesFR.routes,
    seo: seoFR.seo,
  },
};

const defaultLanguage = "en"; // Default language if no previous selection is found

// Get the previously selected language from browser storage
const selectedLanguage = localStorage.getItem("language");

// Set the initial language from storage or use the language from URL
let languageFromURL = selectedLanguage || defaultLanguage;
const pathname = window.location.pathname;
const enRoutePaths = new Set(Object.values(routesEN.routes));
const frRoutePaths = new Set(Object.values(routesFR.routes));

if (frRoutePaths.has(pathname)) {
  languageFromURL = "fr";
  localStorage.setItem("language", "fr");
} else if (enRoutePaths.has(pathname)) {
  languageFromURL = "en";
  localStorage.setItem("language", "en");
} else {
  localStorage.setItem("language", languageFromURL);
}

//i18N Initialization

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: defaultLanguage,
    lng: languageFromURL,
    // keySeparator: false,
    // interpolation: {
    //   escapeValue: false,
    // },
  });

// Set the language in browser storage when it changes
export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  localStorage.setItem("language", lng);
  languageFromURL = lng;
};

export default i18n;
